export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAILvu2ct0a2zg1hXVZk8oLIt54CtEarg4',
    authDomain: 'crown-of-the-realm.firebaseapp.com',
    projectId: 'crown-of-the-realm',
    storageBucket: 'crown-of-the-realm.firebasestorage.app',
    messagingSenderId: '735438236236',
    appId: '1:735438236236:web:b45f9af093379ddbbba2e9',
  },
};
